import {
  Directive,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { UserService } from '@sbd-account-portal/app/core/user/user.service';

/**
 <div *hasPermission="['vieweventlog', 'vieweventlogx']; permissionDenied: noPermissions">
 I can do this!
 </div>
 <div *hasPermission="['vieweventlog', 'vieweventlogx']; op 'OR'; permissionDenied: noPermissions2">
 I can do this! 2
 </div>
 <ng-template #noPermissions>
 <p> YOU CANNOT DO THIS!!!!! ONE ONE one. </p>
 </ng-template>
 <ng-template #noPermissions2>
 <p> YOU CANNOT DO THIS!!!!! TWO TWO two. </p>
 </ng-template>
 */
@Directive({
  selector: '[requiresPermissionCanView]',
  standalone: false,
})
export class RequiresPermissionCanViewDirective implements OnInit {
  private currentUser;
  private permissions = [];
  private logicalOp = 'AND';
  private isHidden = true;

  @Input()
  public permissionDeniedTemplate?: TemplateRef<unknown>;

  constructor(
    private element: ElementRef,
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.userService.user$.subscribe((user) => {
      this.currentUser = user;
      this.updateView();
    });
  }

  @Input()
  set requiresPermissionCanView(val) {
    this.permissions = val;
    this.updateView();
  }

  @Input()
  set requiresPermissionCanViewOp(permissionsOperator) {
    this.logicalOp = permissionsOperator;
    this.updateView();
  }

  @Input()
  set requiresPermissionCanViewPermissionDenied(
    template: TemplateRef<unknown>
  ) {
    this.permissionDeniedTemplate = template;
    this.updateView();
  }

  private updateView() {
    this.viewContainer.clear();

    if (this.checkPermission()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.isHidden = false;
    } else {
      this.isHidden = true;

      if (
        this.permissionDeniedTemplate !== null &&
        this.permissionDeniedTemplate !== undefined
      ) {
        this.viewContainer.createEmbeddedView(this.permissionDeniedTemplate);
      }
    }
  }

  private checkPermission() {
    let requiresPermissionCanView = false;
    if (this.currentUser && this.currentUser.permissions) {
      for (const checkPermission of this.permissions) {
        const permissionFound = this.currentUser.permissions.find(
          (x: string) => x.toUpperCase() === checkPermission.toUpperCase()
        );

        if (permissionFound) {
          requiresPermissionCanView = true;

          if (this.logicalOp === 'OR') {
            break;
          }
        } else {
          requiresPermissionCanView = false;
          if (this.logicalOp === 'AND') {
            break;
          }
        }
      }
    }

    return requiresPermissionCanView;
  }
}
